(() => {
  const init = root => {
    const json = root.querySelector('[data-variant-product]');
    if (!json || root.dataset.experienceReady) return;
    root.dataset.experienceReady = 'true';
    const product = JSON.parse(json.textContent);
    const select = root.querySelector('[data-stone-select], [data-variant-select]');
    if (!select || !product.variants?.length) return;
    const single = root.matches('[data-single-stone]');
    const seasonalSource = root.querySelector('[data-halloween-heroes]');
    const traySource = root.querySelector('[data-halloween-trays]');
    const seasonalTrays = traySource ? JSON.parse(traySource.textContent) : null;
    const seasonalHeroes = seasonalSource ? JSON.parse(seasonalSource.textContent) : null;
    const main = root.querySelector('.product-gallery__main');
    const image = main.querySelector('img');
    const gallery = root.querySelector('[data-current-gallery]');
    const details = [...root.querySelectorAll('[data-variant-detail]')];
    const productRegion = root.querySelector('.product-page__grid');
    const purchaseBar = root.querySelector('.product-mobile-purchase');
    if (productRegion && purchaseBar) {
      // Escape the sticky summary's stacking context so detail images cannot cover the bar.
      root.append(purchaseBar);
      const thumbnail = document.createElement('img');
      thumbnail.className = 'product-purchase-thumbnail';
      thumbnail.alt = ''; thumbnail.width = 56; thumbnail.height = 56;
      const discount = document.createElement('span');
      discount.className = 'product-purchase-discount';
      purchaseBar.querySelector('.product-mobile-purchase__summary').prepend(thumbnail);
      purchaseBar.querySelector('.product-mobile-purchase__summary').append(discount);
      new IntersectionObserver(([entry]) => {
        purchaseBar.classList.toggle('is-desktop-visible', !entry.isIntersecting && entry.boundingClientRect.bottom <= 0);
      }, {threshold: 0}).observe(productRegion);
    }
    const normalize = value => value.toLowerCase().replace(/[’']/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    const setKey = title => /soft return/i.test(title) ? 'love' : /grounded truth/i.test(title) ? 'grounded' : 'abundance';
    const label = option => single ? option.dataset.words || option.dataset.name : option.dataset.title.split(/[：:]/)[0];
    const choices = document.createElement('div');
    choices.className = 'variant-choices';
    choices.setAttribute('role', 'group');
    choices.setAttribute('aria-label', single ? 'Choose your engraved stone' : 'Choose your three-stone set');
    [...select.options].forEach(option => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'variant-choice'; button.dataset.choiceId = option.value;
      const thumb = document.createElement('img'); thumb.src = seasonalHeroes?.[setKey(option.dataset.title)] || option.dataset.image; thumb.alt = ''; thumb.loading = 'lazy';
      const text = document.createElement('span');
      const title = document.createElement('strong'); title.textContent = label(option);
      const subtitle = document.createElement('small'); subtitle.textContent = (single ? option.dataset.name : option.dataset.setStones) + (option.dataset.available !== 'true' ? ' · Sold out' : '');
      text.append(title, subtitle); button.append(thumb, text);
      button.addEventListener('click', () => {select.value = option.value; select.dispatchEvent(new Event('change', {bubbles: true}));});
      choices.append(button);
    });
    const selectLabel = select.closest('label');
    selectLabel.after(choices);
    selectLabel.classList.add('variant-select-fallback');
    const choiceLabel = document.createElement('p');
    choiceLabel.className = 'variant-choice-label';
    choiceLabel.textContent = single ? 'Choose Your Stone' : 'Choose Your Set';
    const choiceCount = document.createElement('span');
    choiceCount.className = 'variant-choice-count';
    choiceCount.textContent = `${select.options.length} options`;
    choiceLabel.append(choiceCount);
    choices.before(choiceLabel);
    // Keep selection ahead of long descriptions, using the existing purchase form.
    const purchase = root.querySelector('.product-summary__purchase');
    const description = root.querySelector('.product-summary__description');
    if (description) description.before(purchase);
    const countdown = root.querySelector('.presale-countdown');
    if (countdown) purchase.before(countdown);
    const assurance = root.querySelector('[data-purchase-assurance]');
    const specifications = root.querySelector('.product-summary__shipping');
    if (assurance && specifications) {
      const information = document.createElement('div');
      information.className = 'product-information';
      root.querySelector('.product-page__grid').after(information);
      information.append(assurance, specifications);
      const compactInformation = matchMedia('(max-width: 800px)');
      [assurance, specifications].forEach((section, index) => {
        const heading = section.querySelector('h2');
        const title = heading.textContent;
        const content = document.createElement('div');
        content.className = 'product-information__content';
        content.id = `product-information-${product.id}-${index}`;
        [...section.children].filter(child => child !== heading).forEach(child => content.append(child));
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'product-information__toggle';
        button.textContent = title; button.setAttribute('aria-controls', content.id);
        const desktopTitle = document.createElement('span');
        desktopTitle.className = 'product-information__desktop-title'; desktopTitle.textContent = title;
        heading.replaceChildren(desktopTitle, button);
        section.append(content);
        let expanded = false;
        let animation;
        const sync = () => {
          animation?.cancel();
          content.hidden = compactInformation.matches && !expanded;
          button.setAttribute('aria-expanded', String(expanded));
        };
        button.addEventListener('click', () => {
          const startHeight = content.getBoundingClientRect().height;
          animation?.cancel();
          expanded = !expanded;
          button.setAttribute('aria-expanded', String(expanded));
          content.hidden = false;
          if (matchMedia('(prefers-reduced-motion: reduce)').matches) {sync(); return;}
          animation = content.animate([
            {height: `${startHeight}px`, opacity: expanded ? 0 : 1, paddingBottom: expanded ? '0px' : '24px', overflow: 'hidden', boxSizing: 'border-box'},
            {height: `${expanded ? content.getBoundingClientRect().height : 0}px`, opacity: expanded ? 1 : 0, paddingBottom: expanded ? '24px' : '0px', overflow: 'hidden', boxSizing: 'border-box'}
          ], {duration: 280, easing: 'cubic-bezier(.2, .7, .2, 1)'});
          animation.onfinish = sync;
        });
        compactInformation.addEventListener('change', sync);
        sync();
      });
    }
    const savings = document.createElement('span'); savings.className = 'product-savings';
    root.querySelector('.product-summary__price').append(savings);
    const offer = document.createElement('div');
    offer.className = 'gallery-offer';
    const offerLabel = document.createElement('span');
    offerLabel.textContent = 'Limited Time Offer';
    const offerDiscount = document.createElement('strong');
    offer.append(offerLabel, offerDiscount);
    main.append(offer);
    const guideSlides = root.querySelector('[data-guide-slides]');
    const guideDots = root.querySelector('[data-guide-dots]');
    const updateGuideCount = () => {
      if (guideSlides && guideDots) [...guideDots.children].forEach((dot, index) => dot.setAttribute('aria-current', String(index === Math.round(guideSlides.scrollLeft / (guideSlides.clientWidth || 1)))));
    };
    guideSlides?.addEventListener('scroll', updateGuideCount, {passive: true});
    ['prev', 'next'].forEach(direction => root.querySelector(`[data-guide-${direction}]`)?.addEventListener('click', () => {
      guideSlides.scrollBy({left: guideSlides.clientWidth * (direction === 'next' ? 1 : -1), behavior: 'smooth'});
    }));
    let previousId;
    const update = () => {
      const option = select.selectedOptions[0];
      const variant = product.variants.find(item => String(item.id) === select.value);
      if (!variant) return;
      root.querySelector('[data-current-heading]').textContent = label(option);
      if (single) root.querySelector('[data-current-subtitle]').textContent = `Engraved ${option.dataset.name} Palm Stone`;
      choices.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.choiceId === select.value)));
      const key = single ? normalize(option.dataset.name) : setKey(variant.title);
      if (seasonalTrays?.[key]) {
        const tray = root.querySelector('[data-halloween-tray]');
        tray.src = seasonalTrays[key];
        tray.alt = `Styling illustration: ${label(option)} stones on the complimentary ghost tray`;
        root.querySelector('[data-halloween-tray-caption]').textContent = `Styling illustration shown with ${label(option)}.`;
      }
      const detail = details.find(item => normalize(item.dataset.variantDetail) === key);
      details.forEach(item => {item.hidden = item !== detail;});

      const writeGuide = (field, text) => {
        const target = root.querySelector(`[data-guide-${field}]`);
        if (target) target.textContent = text;
      };
      if (single && detail) {
        const meaning = detail.querySelector('.single-stone__meaning > p')?.textContent.trim();
        const moments = [...detail.querySelectorAll('.single-stone__moments li')].map(item => item.textContent.trim());
        writeGuide('intro', `${label(option)} — a daily ritual with ${option.dataset.name}.`);
        writeGuide('choose', meaning || `Make “${label(option)}” your intention for today.`);
        writeGuide('practice', `Hold your ${option.dataset.name} stone and take a slow breath. Read “${label(option)}” and consider what those words mean to you today.`);
        writeGuide('place', moments.length ? `Keep it within reach: ${moments[0].charAt(0).toLowerCase()}${moments[0].slice(1)}.` : 'Keep it in your pocket, on your desk, or beside your bed.');
        writeGuide('stones', `${option.dataset.name}, with its own natural colors, patterns, and texture. Your stone will be uniquely yours.`);
        writeGuide('words', `“${label(option)}” is engraved into the stone—a physical reminder you can return to throughout the day.`);
        writeGuide('gift', `Give “${label(option)}” as a small expression of care, or keep it as a reminder for yourself.`);
      } else if (!single) {
        const copy = {
          love: [
            'Soft Return — a little room for kindness, clarity, and calm.',
            'Choose the reminder you need: I Am Safe To Love, Light Moves Through Me, or Return To Peace.',
            'Hold one stone and take a slow breath. Ask yourself: where could I be kinder to myself, see more clearly, or soften my pace?',
            'Keep one at your bedside for a quiet evening pause, or on your desk when the day feels full.',
            'Three engraved reminders for self-kindness, a clearer perspective, and a moment of calm.',
            'A thoughtful gesture for someone who could use a gentler moment. Keep the set together, or share its reminders.'
          ],
          grounded: [
            'Grounded Truth — stay true, make room for change, and set down what feels heavy.',
            'Choose I Stand In My Truth, I Am Rooted But I Flow, or I Release What Is Heavy to meet the moment you are in.',
            'Hold one stone and pause before responding. Consider what matters to you, where you can be flexible, and what you can leave behind.',
            'Keep a stone near your workspace or carry it into a day of decisions, change, or difficult conversations.',
            'Three engraved reminders for honest expression, flexibility, and letting go.',
            'For someone navigating change or learning to honor their boundaries. Share a reminder, or keep all three close.'
          ],
          abundance: [
            'Begin Again — small steps, a little courage, and room to enjoy the journey.',
            'Choose Good Things Grow for patience, the sun symbol for a fresh start, or Viva la Vida for a fuller everyday life.',
            'Hold one stone and take a breath. Name one small next step, one thing worth tending, or one moment you want to enjoy today.',
            'Place a stone beside your journal or carry it as you begin a project, enter a new chapter, or make time for something you love.',
            'Three engraved reminders for patient growth, new beginnings, and the joy of being here.',
            'Mark a new chapter, celebrate a small milestone, or encourage someone starting again.'
          ]
        }[key];
        if (copy) ['intro', 'choose', 'practice', 'place', 'words', 'gift'].forEach((field, index) => writeGuide(field, copy[index]));
        if (seasonalHeroes) {
          writeGuide('intro', `${copy[0].split(' — ')[0]} — a quiet moment for the season of change. Three stones, your words, and a little Halloween spirit.`);
          writeGuide('practice', 'As the evenings grow longer, hold your stone and take a slow breath. Notice what you want to welcome in — and what you are ready to let go.');
          writeGuide('place', 'Set your stones in the complimentary ghost tray, beside your bed or on your desk. Keep a small reminder close through Halloween and beyond.');
        }
        writeGuide('stones', `${option.dataset.setStones}. Each stone has its own natural colors, patterns, and texture.`);
      }
      const setPhoto = root.querySelector('[data-guide-set-photo]');
      const setPhotoSource = setPhoto && detail?.querySelector('.fixed-sets__media--real img');
      if (setPhoto && setPhotoSource) {setPhoto.src = setPhotoSource.src; setPhoto.alt = setPhotoSource.alt;}
      const guidePhotos = root.querySelector('[data-guide-photos]');
      if (guideSlides) {
        const photos = guidePhotos ? JSON.parse(guidePhotos.textContent) : {};
        const selectedPhotos = [].concat(photos[key] || option.dataset.image);
        guideSlides.replaceChildren();
        guideDots.replaceChildren();
        selectedPhotos.forEach((src, index) => {
          const img = document.createElement('img');
          img.src = src; img.alt = `${label(option)} — lifestyle photo ${index + 1}`;
          img.width = 1400; img.height = 1400; img.loading = 'lazy';
          const framing = !single && (
            src.includes('kova-social-yellow-quartz-hand.webp') ? 'yellow' :
            src.includes('kova-photo-obsidian-hand.webp') ? 'obsidian' :
            src.includes('kova-photo-fluorite-hand-wide.webp') ? 'fluorite' : ''
          );
          if (framing) {
            const frame = document.createElement('div');
            frame.className = `stone-guide__slide stone-guide__slide--${framing}`;
            frame.append(img);
            guideSlides.append(frame);
          } else guideSlides.append(img);
          const dot = document.createElement('button');
          dot.type = 'button'; dot.setAttribute('aria-label', `Show lifestyle photo ${index + 1}`);
          dot.addEventListener('click', () => guideSlides.scrollTo({left: guideSlides.clientWidth * index, behavior: 'smooth'}));
          guideDots.append(dot);
        });
        guideSlides.scrollLeft = 0;
        root.querySelector('[data-guide-controls]').hidden = selectedPhotos.length < 2;
        guideDots.hidden = selectedPhotos.length < 2;
        updateGuideCount();
      }
      const discount = variant.compare_at_price > variant.price && variant.price >= 0;
      const purchaseThumbnail = purchaseBar?.querySelector('.product-purchase-thumbnail');
      const purchaseDiscount = purchaseBar?.querySelector('.product-purchase-discount');
      if (purchaseThumbnail) purchaseThumbnail.src = option.dataset.image;
      if (purchaseDiscount) {
        purchaseDiscount.hidden = !discount;
        purchaseDiscount.textContent = discount ? `${Math.round((1 - variant.price / variant.compare_at_price) * 100)}% OFF` : '';
      }
      savings.hidden = !discount;
      offerDiscount.textContent = discount ? `${Math.round((1 - variant.price / variant.compare_at_price) * 100)}% OFF` : '';
      offer.hidden = !discount;
      savings.replaceChildren();
      if (discount) {
        const percent = document.createElement('b'); percent.textContent = `${Math.round((1 - variant.price / variant.compare_at_price) * 100)}% OFF`;
        savings.append(percent);
      }
      const mobileTitle = root.querySelector('[data-mobile-variant-title], [data-stone-mobile-name]');
      if (mobileTitle) mobileTitle.textContent = label(option);
      const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState(null, '', url);
      if (previousId === select.value) return;
      previousId = select.value;
      const featured = variant.featured_image;
      // Shopify image IDs and media IDs differ; match the source pathname.
      const sourceKey = src => new URL(src, location.href).pathname;
      const isFeatured = item => featured?.src && sourceKey(item.src || item.preview_image?.src) === sourceKey(featured.src);
      const tokens = single ? [normalize(option.dataset.name)] : key === 'love' ? ['love light', 'soft return'] : key === 'grounded' ? ['grounded peace', 'grounded truth'] : ['abundance', 'begin again'];
      const media = product.media.filter(item => isFeatured(item) || (single || item.media_type !== 'image') && tokens.some(token => normalize(`${item.alt || ''} ${item.src || ''} ${item.preview_image?.src || ''}`).includes(token)));
      media.sort((a, b) => Number(isFeatured(b)) - Number(isFeatured(a)));
      const entries = media.map(item => ({src: item.src || item.preview_image?.src, alt: item.alt || label(option), media: item}));
      if (!entries.length) entries.push({src: option.dataset.image, alt: label(option)});
      if (seasonalHeroes) {
        const src = seasonalHeroes[key];
        if (src) entries.splice(0, 1, {src, alt: `${label(option)} — Halloween three-stone set`});
      }
      const detailImages = [...(detail?.querySelectorAll('img') || [])];
      if (!single) {
        const realPhoto = detailImages.pop();
        if (realPhoto) entries.splice(1, 0, {src: realPhoto.src, alt: realPhoto.alt});
      }
      detailImages.forEach(img => entries.push({src: img.src, alt: img.alt}));
      if (single) {
        const extras = root.querySelector('[data-single-extra-photos]');
        (extras ? JSON.parse(extras.textContent)[key] || [] : []).forEach(src => entries.push({src, alt: `${label(option)} — ${option.dataset.name}`}));
      }
      const unique = entries.filter((entry, index) => entries.findIndex(other => sourceKey(other.src) === sourceKey(entry.src)) === index);
      if (single) {
        const used = new Set([...(detail?.querySelectorAll('img') || []), ...(guideSlides?.querySelectorAll('img') || [])].map(img => sourceKey(img.src)));
        const featurePhotos = unique.filter(entry => !(key === 'amethyst' && entry.src.includes('kova-photo-amethyst-hand.webp')) && !used.has(sourceKey(entry.src)) && (!entry.media || entry.media.media_type === 'image'));
        if (key === 'amethyst') featurePhotos.sort((a, b) => Number(b.src.includes('kova-photo-amethyst-sand.webp')) - Number(a.src.includes('kova-photo-amethyst-sand.webp')));
        const featureSources = root.querySelector('[data-guide-feature-photos]');
        const dedicatedPhoto = featureSources ? JSON.parse(featureSources.textContent)[key] : null;
        root.querySelectorAll('[data-guide-feature-photo]').forEach((img, index) => {
          const entry = index === 1 && dedicatedPhoto ? {src: dedicatedPhoto, alt: `${label(option)} — ${option.dataset.name} detail photo`} : featurePhotos[index];
          img.closest('li').hidden = !entry;
          if (entry) {img.src = entry.src; img.alt = entry.alt; img.dataset.stonePhoto = key;}
        });
      }
      let activeIndex = 0;
      const show = (entry, button) => {
        activeIndex = unique.indexOf(entry);
        offer.hidden = !discount || activeIndex !== 0;
        main.querySelectorAll('video, iframe, model-viewer').forEach(node => node.remove());
        const template = root.querySelector(`template[data-media-id="${entry.media?.id}"]`);
        const playable = template?.content.firstElementChild;
        image.hidden = Boolean(playable);
        if (playable) main.prepend(playable.cloneNode(true));
        else {image.src = entry.src; image.alt = entry.alt;}
        gallery.querySelectorAll('button').forEach(thumb => {thumb.classList.toggle('is-active', thumb === button); thumb.setAttribute('aria-current', String(thumb === button));});
      };
      main.querySelectorAll('.gallery-nav').forEach(button => button.remove());
      gallery.replaceChildren();
      unique.forEach((entry, index) => {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'product-gallery__thumb';
        button.setAttribute('aria-label', `Show ${entry.media?.media_type === 'video' ? 'video' : 'image'} ${index + 1}: ${entry.alt}`);
        const thumb = document.createElement('img'); thumb.src = entry.src; thumb.alt = ''; thumb.loading = 'lazy'; button.append(thumb);
        button.addEventListener('click', () => show(entry, button)); gallery.append(button);
      });
      if (unique.length > 1) {
        [-1, 1].forEach(direction => {
          const arrow = document.createElement('button');
          arrow.type = 'button';
          arrow.className = `gallery-nav gallery-nav--${direction < 0 ? 'previous' : 'next'}`;
          arrow.setAttribute('aria-label', direction < 0 ? 'Previous image' : 'Next image');
          const icon = document.createElement('span');
          icon.textContent = direction < 0 ? '‹' : '›';
          icon.setAttribute('aria-hidden', 'true');
          arrow.append(icon);
          arrow.addEventListener('click', event => {
            event.stopPropagation();
            const next = (activeIndex + direction + unique.length) % unique.length;
            const thumb = gallery.querySelectorAll('button')[next];
            show(unique[next], thumb);
          });
          main.append(arrow);
        });
      }
      let touchStart;
      main.ontouchstart = event => {touchStart = {x: event.touches[0].clientX, y: event.touches[0].clientY};};
      main.ontouchend = event => {
        if (!touchStart) return;
        const dx = event.changedTouches[0].clientX - touchStart.x;
        const dy = event.changedTouches[0].clientY - touchStart.y;
        touchStart = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
        const next = (activeIndex + (dx < 0 ? 1 : -1) + unique.length) % unique.length;
        show(unique[next], gallery.querySelectorAll('button')[next]);
      };
      show(unique[0], gallery.firstElementChild);
    };
    select.addEventListener('change', update);
    root.querySelectorAll('[data-review-entry]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault(); const tab = document.getElementById(link.dataset.reviewEntry);
      tab?.click(); tab?.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'}); tab?.focus({preventScroll: true});
    }));
    window.addEventListener('popstate', () => {
      const id = new URL(location.href).searchParams.get('variant');
      if ([...select.options].some(option => option.value === id)) {
        select.value = id; select.dispatchEvent(new Event('change', {bubbles: true}));
      }
    });
    update();
  };
  document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('[data-single-stone], [data-kova-product]').forEach(init));
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-single-stone], [data-kova-product]').forEach(init));
})();
